import { withPopup } from '../lib/popup';

import GroupCountriesStep from './GroupCountriesStep';

export default withPopup(GroupCountriesStep);
